<template lang="pug">
  section.follow-us(:class="followUsClasses")
    icon.follow-us__squiggle-left(
      name="follow-us-squiggle-left"
      :width="isMobile ? '150px' : '348px'"
      :height="isMobile ? '300px' : '451px'"
    )
    icon.follow-us__squiggle-right(
      name="follow-us-squiggle-right"
      :width="isMobile ? '30px' : '82px'"
      :height="isMobile ? '275px' : '657px'"
    )
    h2.follow-us__headline {{ headline }}
    a.follow-us__link(:href="socialLinkUrl") {{ socialLinkText }}
    .follow-us__instafeed(
      v-if="useInstafeedApp"
      id="insta-feed"
    )
    carousel.carousel--follow-us(
      v-else
      :slides-to-show="isMobile ? 1.3 : 5"
      :center-mode="isMobile"
      :dots="isMobile"
    )
      slide.slide--follow-us(
        v-for="(image, index) in socialImages"
        :key="`${image.src}__${index}`"
      )
        responsive-image(
          :src="image.src"
          :alt="image.alt"
          :draggable="false"
        )
</template>

<script>
  import Carousel from 'scripts/components/basic/Carousel.vue';
  import Slide from 'scripts/components/basic/Slide.vue';
  import ResponsiveImage from 'scripts/components/basic/ResponsiveImage.vue';
  import Icon from 'scripts/components/basic/Icon.vue';

  export default {
    components: {
      Carousel,
      Slide,
      ResponsiveImage,
      Icon,
    },
    props: {
      headline: String,
      extraTopPadding: Boolean,
      socialLinkText: String,
      socialLinkUrl: String,
      useInstafeedApp: Boolean,
      socialImages: {
        type: Array,
        default: () => [
          {
            src: String,
            alt: String,
          },
        ],
      },
    },
    computed: {
      isMobile() {
        return ['mobile', 'tablet'].includes(this.$mq);
      },
      followUsClasses() {
        return {
          'follow-us--extra-top-padding': this.extraTopPadding,
        };
      },
    },
  };
</script>

<style lang="scss">
  /*
   * 1. High specificity selector to override
   * third party styles.
   */

  .follow-us {
    position: relative;
    padding: $spacing-unit * 8 0 $spacing-unit * 10 0;
    text-align: center;
    background-color: $color-green-900;

    @include desktop-up {
      margin-top: -185px;
      padding: $spacing-unit * 13 0 $spacing-unit * 25 0;
    }
  }

  .follow-us--extra-top-padding {
    @include desktop-up {
      padding-top: $spacing-unit * 56;
    }
  }

  .follow-us__squiggle-left {
    position: absolute;
    top: -70px;
    left: -100px;

    @include desktop-up {
      top: -80px;
      left: 0;
    }

    .follow-us--extra-top-padding & {
      @include desktop-up {
        top: 129px;
      }
    }
  }

  .follow-us__squiggle-right {
    position: absolute;
    top: 235px;
    right: 0;
    z-index: index($follow-us, right-squiggle);
    pointer-events: none;

    @include desktop-up {
      top: 413px;
    }
  }

  .follow-us__headline {
    margin: 0 0 $spacing-unit * 4 0;
    color: $color-green-900;
    font-size: rem(34);
    line-height: rem(40);
  }

  .follow-us__link {
    color: $color-green-900;
    font-size: rem(16);
    line-height: rem(22);
    letter-spacing: 0.4px;
    text-transform: uppercase;
  }

  /* stylelint-disable selector-max-id, declaration-no-important */
  #insta-feed.follow-us__instafeed { /* [1] */
    margin: 23px auto 0 auto;
    max-width: 1300px;

    .instafeed-container {
      padding-top: 50% !important;
      width: 50% !important;

      @include tablet-up {
        padding-top: 25% !important;
        width: 25% !important;
      }
    }
  }
  /* stylelint-enable selector-max-id, declaration-no-important */
</style>
